:host {
    --offset: 0;
    div.counter {

        align-items: flex-start;
        display: flex;

        [part='prefix']{
            align-self: center;
            line-height: 1em;
        }
        [part='counter']{
            line-height: 1em;
            font-size: 60px;
            font-weight: bolder;
            display: flex;
            flex-wrap: nowrap;
        }
        [part='suffix'] {
            line-height: 1em;
            font-size: 16px;
        }

        [part='digit'] {
            font-size: 1em;
            overflow: hidden;
            height: 1em;
            display: inline-block;

            .numbers {
                transition: transform .1s ease-out;
                transform: translateY(var(--offset));

                span {
                    display: block;
                    height: 1em;
                }
            }
        }
    }
}
